import { expandWithMerge, expand } from 'inline-style-expand-shorthand';

function resolveShorthands(style, shouldMerge) {
  if (shouldMerge) {
    return expandWithMerge(style);
  }

  return expand(style);
}

export default function expandShorthand() {
  var merge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function expandShorthandPlugin(style) {
    return resolveShorthands(style, merge);
  };
}